import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, SHIPPING_PARTNERS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

const CityCoverageList = () => {
	const { state } = useLocation();
	const { id, icon, name, settingsID } = state;

	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'cityId', filterType: FilterType.number, width: 200, show: false },
			{ Header: 'city', accessor: 'city', filterType: FilterType.multiSelection, width: 200 },
			{ Header: 'country', accessor: 'country', filterType: FilterType.multiSelection, width: 200 },
			{ Header: 'dailyCapacity', accessor: 'capacity', filterType: FilterType.number, width: 200 },
			{
				Header: 'status',
				accessor: 'status',
				renderCell: ListComponents.STATUS,
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ACTIVE_PASSIVE,
				filterPrefix: 'status.',
				width: 100,
				showOnMobile: true
			}
		],
		[]
	);

	const defaultFilters = useMemo(
		() => [
			{
				column: {
					Header: 'deliveryCompSettingsID',
					accessor: 'deliveryCompSettingsID',
					filterType: FilterType.number,
					width: 200,
					filterVisible: false
				},
				action: FilterAction.contains,
				value: settingsID
			}
		],
		[id]
	);

	const defaultSort = useMemo(() => [{ id: 'city', desc: false }], []);

	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader
					lightTitle={name}
					boldTitle="cityCoverage"
					logo={icon}
					icon={faArrowLeft}
					backUrl={mergePaths(PATHS.SHIPPING_PARTNERS, PATHS.CONNECTED_PARTNERS)}
				/>
			</HeaderContainerFormHeader>
			<DynamicList
				id={DYNAMICLISTS.SHIPPING_PARTNER_CITY_COVERAGE}
				columns={columns}
				fetchUrl={SHIPPING_PARTNERS.GET_CITY_COVERAGE_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.SHIPPING_PARTNERS}
				defaultSort={defaultSort}
				defaultFilters={defaultFilters}
				exportName="cityCoverageList"
			/>
		</div>
	);
};

export default CityCoverageList;
